export default "__VITE_ASSET__D19pmlcg__ 720w";